export const onBoardingStatusMessages = {
  ON_BOARDINGSTATUS_PAGE: {
    TITLE: 'The analysis is underway',
    SUBTITLE:
      'You will receive an alert on your email once it’s ready for review, or you can return in 60–90 minutes',
    STATUS_TITLES: [
      'Upload File',
      'Select Analysis',
      'Processing Report',
      'Report Generated',
      'Risk Register Generated',
    ],
    LOCATE_TITLE: 'Go to Homepage',
  },
};
